import {
  ClickAwayListener as MuiClickAwayListener,
  ClickAwayListenerProps as MuiClickAwayListenerProps,
} from '@mui/material';

export type ClickAwayListenerProps = MuiClickAwayListenerProps;

export const ClickAwayListener = MuiClickAwayListener;
